import { render } from "./PopUpNewKabanTask.vue?vue&type=template&id=490f7840"
import script from "./PopUpNewKabanTask.vue?vue&type=script&lang=js"
export * from "./PopUpNewKabanTask.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__